import React, { memo, useCallback, useContext } from 'react'

import { func } from 'prop-types'

import WaitlistCard from 'Pods/Shared/Waitlist/WaitlistCard/WaitlistCard'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import AiTermsNotice from 'Pods/ThreeDStudio/Shared/UsageBodies/AiTermsNotice/AiTermsNotice'
import applyAccessCodeResult from 'Pods/ThreeDStudio/Shared/Utils/applyAccessCodeResult'
import { setStudioAccessTier } from 'Pods/ThreeDStudio/Store/actions/subscription'
import { STUDIO_ACCESS_TIER } from 'Pods/ThreeDStudio/Store/constants'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import SubscriptionCard from '../SubscriptionCard/SubscriptionCard'

function JoinWaitlistBody({ onClose: handleClose }) {
  const t = useTranslation()
  const { locale } = useContext(ThreeDStudioPageContext)

  const handleJoined = useCallback((data) => {
    setStudioAccessTier(data.studioAccessTier || STUDIO_ACCESS_TIER.WAITLISTED)
  }, [])

  return (
    <div className="usage-modal__join-waitlist">
      <p className="usage-modal__headline cgt-body-md">
        {t('usageModal.setupHeadline')}
      </p>

      <div className="usage-modal__cards">
        <WaitlistCard
          onJoined={handleJoined}
          onCodeApplied={applyAccessCodeResult}
          onClose={handleClose}
          locale={locale}
        />
        <SubscriptionCard onClose={handleClose} />
      </div>

      <AiTermsNotice />
    </div>
  )
}

JoinWaitlistBody.propTypes = {
  onClose: func.isRequired,
}

export default memo(JoinWaitlistBody)
